module.exports = __webpack_public_path__ + "img/25-min.a59b4855.jpg";